const FRACTION_RE = /(^|[^0-9])(\d+)\s*\/\s*(\d+)(?!\d)/g;

const OUVRE_SVG = /^<svg[\s>]/i;
const FERME_SVG = /^<\/svg\s*>$/i;
const AUTO_FERMANTE = /\/>$/;

/**
 * Empile les fractions « a/b » du texte, SANS entrer dans les figures.
 *
 * Le découpage se fait sur les balises ; tout ce qui n'en est pas une est du
 * texte, et recevait le traitement. Les étiquettes situées dans un `<svg>` en
 * faisaient partie — or `<span>` n'est pas un élément SVG et n'y a aucun
 * rendu. Une droite graduée en tiers perdait donc ses étiquettes 1/3 et 2/3 :
 * le générateur produisait une figure juste, le navigateur n'en affichait
 * qu'une partie. C'est le rendu mathématique cassé constaté sur téléphone.
 *
 * On compte donc la profondeur SVG en avançant, et on laisse ce qui est
 * dedans exactement tel quel. Un `<svg>` non refermé protège tout ce qui le
 * suit : mieux vaut ne pas formater que produire du balisage invalide.
 */
export const formatFractionsHtml = (html = "") => {
  if (!html) {
    return html;
  }

  const parts = html.split(/(<[^>]+>)/g);
  let profondeurSvg = 0;

  return parts
    .map((part) => {
      if (!part) {
        return part;
      }

      if (part.startsWith("<")) {
        if (OUVRE_SVG.test(part) && !AUTO_FERMANTE.test(part)) {
          profondeurSvg += 1;
        } else if (FERME_SVG.test(part) && profondeurSvg > 0) {
          profondeurSvg -= 1;
        }
        return part;
      }

      if (profondeurSvg > 0) {
        return part;
      }

      return part.replace(FRACTION_RE, (_, prefix, num, den) => {
        return (
          `${prefix}<span class="frac">` +
          `<span class="frac-num">${num}</span>` +
          `<span class="frac-den">${den}</span>` +
          `</span>`
        );
      });
    })
    .join("");
};
